







import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import BpcAccessControlBadgeList from '@access-control/components/access-control-badge-list.vue';

@Component({
  name: 'bpc-access-control-badges',
  components: {
    'bpc-access-control-badge-list': BpcAccessControlBadgeList,
  },
})
export default class AccessControlBadges extends Vue {}
